import styled from "@emotion/styled";
import { ScreenSize } from "@constants/screen-size";

const CallerImage = styled.img`
  max-width: 100%;
  height: 300px;
  width: 300px;
  aspect-ratio: 1;
  border-radius: 50%;
  object-fit: cover;
  object-position: top;
  background-color: #a59e8f;

  @media (orientation: landscape) and (max-height: ${ScreenSize.sm}px) {
    height: 150px;
    width: 150px;
  }
`;

export default CallerImage;
